module.exports = __webpack_public_path__ + "static/media/css.b8440648.png";